import { render, staticRenderFns } from "./MemorandumDetailModal.vue?vue&type=template&id=917c863e&scoped=true"
import script from "./MemorandumDetailModal.vue?vue&type=script&lang=js"
export * from "./MemorandumDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MemorandumDetailModal.vue?vue&type=style&index=0&id=917c863e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917c863e",
  null
  
)

export default component.exports